import { lazyLoad } from 'utils/loadable';

export const CourseListPage = lazyLoad(
  () => import('./index'),
  module => module.CourseListPage,
);
